import { toolbarMinHeight } from '../../../editor/core/EditorConstants';

export default {
  toolbar: {
    minHeight: toolbarMinHeight
  },
};
